import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";

export const dealRushImpressionEvent = ({
    text,
    impressionEvent,
    timer,
    offer,
}: {
    text: string;
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    timer?: number;
    offer?: string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ text, ...(!isEmpty(timer) && { timer }), offer }),
        action: IMPRESSION_ACTIONS.IMPRESSION_CROUTON_DEAL_RUSH,
    });
};

export const dealRushClickEvent = ({
    text,
    clickEvent,
    timer,
    offer,
}: {
    text: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
    timer?: number;
    offer?: string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ text, ...(!isEmpty(timer) && { timer }), offer }),
        action: CLICK_ACTIONS.CLICK_DEAL_RUSH_CROUTON_CLOSE_ICON,
    });
};

export const dealRushExpiredImpressionEvent = (
    text: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    offer?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ text, offer }),
        action: IMPRESSION_ACTIONS.IMPRESSION_CROUTON_DEAL_RUSH_EXPIRED,
    });
};
